module.exports = __webpack_public_path__ + "static/media/front.c3687811.jpg";